import styled from 'styled-components';
export const DataCardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    // align-items: center;
`;
